import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/auth";
import { PageHeader } from "@/pages/Classes";
import { ArrowRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then(r => setPosts(r.data.filter(p => p.published))); }, []);
  return (
    <>
      <PageHeader eyebrow="From 2RightFeet" title="Our Story" />
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 py-12 grid md:grid-cols-2 gap-6">
        {posts.map(p => (
          <Link to={`/blog/${p.slug || p.id}`} key={p.id} className="card-surface overflow-hidden card-hover block group" data-testid={`blog-card-${p.id}`}>
            {p.cover && <img src={p.cover} alt="" loading="lazy" className="w-full aspect-[16/10] object-cover group-hover:scale-[1.02] transition-transform duration-500"/>}
            <div className="p-6">
              <div className="eyebrow mb-2">{p.category || "Story"}</div>
              <h2 className="font-display text-3xl uppercase leading-none">{p.title}</h2>
              <p className="text-zinc-400 mt-3">{p.excerpt}</p>
              <div className="flex items-center justify-between mt-4">
                <p className="text-zinc-500 text-xs">by {p.author}</p>
                <span className="text-red-500 text-xs uppercase tracking-widest flex items-center gap-1">Read <ArrowRight size={12}/></span>
              </div>
            </div>
          </Link>
        ))}
        {posts.length === 0 && <div className="col-span-full text-zinc-500 text-center py-20">No posts yet.</div>}
      </div>
    </>
  );
}
